import { useTheme } from "@mui/material";
import React, { useMemo } from "react";
import { ResponsiveLine } from "@nivo/line";

function PM25Graph({ plots }) {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const lineColor = isDark ? "#3ab9c9" : "#008c64";
  const fontColor = isDark ? "#FFFFFF" : "#000000";
  const monthOrder = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];

  const entries = useMemo(() => {
    if (!plots) return [];
    return Object.entries(plots)
      .sort(([a], [b]) => monthOrder.indexOf(a) - monthOrder.indexOf(b))
      .map(([x, y]) => ({ x, y: Number(y) }))
      .filter(p => Number.isFinite(p.y));
  }, [plots]);

  if (entries.length === 0) return null;

  const nivoData = [
    { id: "PM2.5", data: entries }
  ];

  return (
    <div style={{ width: 230, height: 140, background: "#000" }}>
      <div
        style={{
          position: "absolute",
          top: 4,
          left: "1%",
          zIndex: 1,
          color: fontColor,
          fontFamily: "Inter, sans-serif",
          fontSize: 12,
          fontWeight: 600,
          pointerEvents: "none",
          textAlign: "center",
          width: "100%",
        }}
    >
    PM2.5 Conc.
  </div>
      <ResponsiveLine
        data={nivoData}
        colors={[lineColor]}
        xScale={{ type: "point" }}      // categorical x: Apr, Jun...
        yScale={{ type: "linear", min: "auto", max: "auto", stacked: false }}
        axisTop={null}
        axisRight={null}
        axisLeft={null}                 // like your showYAxisValues=0
        axisBottom={{
          tickRotation: -45,            // like rotate labels
          tickPadding: 6,
          tickSize: 0,
        }}
        enableGridX={false}
        enableGridY={false}
        enablePoints={true}
        pointSize={5}
        pointColor={lineColor}
        pointBorderWidth={0}
        useMesh={true}
        yFormat={(v) => Math.round(v)}
        tooltip={({ point }) => (
          <div style={{ padding: 6, background: isDark ? "#000" : "#fff", color: fontColor }}>
            <div>{point.data.yFormatted}</div>
          </div>
        )}
        margin={{ top: 30, right: 50, bottom: 50, left: 15 }}
      />
    </div>
  );

}

export default PM25Graph;
